import Permissions from '../../models/Permissions'
const Search = () => import(/* webpackChunkName: "questionnaire" */ './Search.vue')
const Questionnaire = () => import(/* webpackChunkName: "questionnaireConfig" */ './Questionnaire.vue')

const permissions = [
  Permissions.ROOT,
  Permissions.ADMINISTRADOR
]

const retrieve = {
  path: 'questionnaire',
  name: 'Questionários',
  component: Search,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const config = {
  path: 'questionnaire/config',
  name: 'Manutenção Questionário',
  component: Questionnaire,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

export default {
  retrieve,
  config
}



// WEBPACK FOOTER //
// ./src/views/questionnaire/index.js